import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { StatusBadge, formatDateTime } from "@/components/admin/ui";

const STATUSES = ["Active", "Onboarding", "Paused", "Suspended", "Inactive"];

export default function OrgWorkspaceHeader({ org, requirements, onStatusChange }) {
  const blockActive = org.status === "Onboarding" && !requirements.ready_for_activation;
  return (
    <div className="space-y-4" data-testid="org-workspace-header">
      <div className="flex items-center gap-1.5 text-sm font-semibold text-slate-500 dark:text-slate-400" data-testid="org-workspace-breadcrumb">
        <Link to="/admin/organizations" data-testid="org-workspace-breadcrumb-link" className="hover:text-blue-600 dark:hover:text-blue-400">Organizations</Link>
        <ChevronRight size={14} />
        <span className="text-slate-900 dark:text-white">{org.name}</span>
      </div>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <div className="flex flex-wrap items-center gap-3">
            <h1 className="text-3xl font-extrabold tracking-tight text-slate-950 dark:text-white" data-testid="org-workspace-name">{org.name}</h1>
            <StatusBadge status={org.status} testId="org-workspace-status" />
          </div>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400" data-testid="org-workspace-meta">{org.org_id} · Created {formatDateTime(org.created_at)}</p>
        </div>
        <select
          value={org.status}
          onChange={(e) => onStatusChange(e.target.value)}
          data-testid="org-workspace-status-select"
          className="rounded-xl border border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold dark:border-white/15 dark:bg-white/5 dark:text-white"
        >
          {STATUSES.map((s) => (
            <option
              key={s}
              value={s}
              disabled={s === "Active" && blockActive}
              title={s === "Active" && blockActive ? "Complete remaining activation requirements first" : undefined}
            >
              {s}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
